var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "transition",
    { attrs: { name: "fade", mode: "out-in" } },
    [
      _vm.loaded
        ? [
            _vm.isLoadingRoute || _vm.isFullPage
              ? _c("router-view")
              : _vm.isLoggedInUser && !_vm.onBoarding
              ? _c(
                  "div",
                  {
                    key: "layout-1",
                    staticClass: "t-wrapper",
                    class: {
                      [`t-wrapper-${_vm.$route.name}`]: _vm.$route.name,
                      "t-wrapper--trial":
                        (_vm.subscription &&
                          _vm.subscription.status == "in_trial" &&
                          !_vm.canShowLimitExceeded &&
                          _vm.canShowBanner) ||
                        _vm.canShowLimitExceeded ||
                        _vm.canShowCreatorWarning,
                    },
                  },
                  [
                    !_vm.ignoreNav
                      ? _c(
                          "div",
                          {
                            staticClass: "t-wrapper__nav",
                            class: {
                              "t-wrapper__nav--collapsed": _vm.$isMobile,
                            },
                          },
                          [_c("Nav", { attrs: { message: _vm.message } })],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "t-wrapper__body",
                        attrs: { id: "page-body" },
                      },
                      [
                        _vm.canShowCreatorWarning
                          ? _c("div", { class: ["t-banner"] }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "home.usageLimit.creatorWarning.text"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "t-td--border t-mar--l-ti",
                                  attrs: { href: "/settings/pricing" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "home.usageLimit.creatorWarning.cta1"
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "t-button t-button--xtiny t-button--primary-ghost t-mar--l-mi",
                                  attrs: {
                                    href: "https://hello.trainn.co/meetings/mansi-jawandhiya",
                                    target: "_blank",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "home.usageLimit.creatorWarning.cta2"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.subscription &&
                        _vm.subscription.status == "in_trial" &&
                        !_vm.canShowLimitExceeded &&
                        _vm.canShowBanner
                          ? _c("div", { class: ["t-banner"] }, [
                              _c("span", [
                                _vm._v("Need help setting up Trainn?"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "t-button t-button--xtiny t-button--primary-ghost t-mar--l-xs",
                                  attrs: {
                                    href: "https://hello.trainn.co/meetings/mansi-jawandhiya/15-min?utm_source=in_product&utm_medium=banner",
                                    target: "_blank",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            Book 15 mins with us\n            "
                                  ),
                                  _c("i", {
                                    staticClass:
                                      "mdi mdi-arrow-right mdi-18px t-mar--l-ti",
                                  }),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.canShowLimitExceeded
                          ? _c("div", {
                              staticClass: "t-banner t-pad--t-mi t-pad--b-mi",
                              domProps: { innerHTML: _vm._s(_vm.bannerText) },
                            })
                          : _c("portal-target", {
                              staticClass: "t-banner",
                              attrs: { name: "banner" },
                            }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "t-wrapper__header" },
                          [
                            _c("Header"),
                            _vm._v(" "),
                            _c("portal-target", {
                              attrs: { name: "banner-actions" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            class: { "t-wrapper__block": !_vm.isFullPageRoute },
                          },
                          [
                            _c("router-view", {
                              key:
                                !_vm.$route.meta.keepalive &&
                                _vm.$route.name +
                                  (_vm.$route.params.videoId ||
                                    _vm.$route.params.collectionId ||
                                    _vm.$route.params.pageName ||
                                    _vm.$route.params.instanceId ||
                                    ""),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    [
                      _vm.workspace.name == "intercom-demo-account"
                        ? _c("IntercomWidget")
                        : _c("FreshdeskWidget"),
                    ],
                    _vm._v(" "),
                    _c("create-video-modal"),
                    _vm._v(" "),
                    _c("UploadVideoModal"),
                    _vm._v(" "),
                    _c("ShowVideoModal"),
                    _vm._v(" "),
                    _c("create-folder-modal"),
                  ],
                  2
                )
              : _c(
                  "div",
                  { key: "layout-2", staticClass: "t-onboard" },
                  [
                    _c(
                      "transition",
                      { attrs: { name: "fade", mode: "out-in" } },
                      [_c("router-view")],
                      1
                    ),
                  ],
                  1
                ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }